import Vue from 'vue';
import axios from 'axios';
import store from '@/store';
import router from '@/router';

let errors = {};

const cancelFunctions = {};

function request(action, data = {}, isExclusive = false, id = 0, method = 'GET') {
  return new Promise((resolve, reject) => {
    const config = {
      method,
      url: 'https://api.vsenauka.ru/API/v1.0/',
    };

    if (method === 'GET') {
      config.params = {
        action,
        access_token: store.getters.token,
        ...data,
      };
    } else if (method === 'POST') {
      config.url += `?action=${action}&access_token=${store.getters.token}`;
      const formData = new FormData();
      // eslint-disable-next-line
      for (const key in data) {
        formData.set(key, data[key]);
      }
      config.data = formData;
    }

    if (isExclusive) {
      if (cancelFunctions[id]) {
        cancelFunctions[id]('canceled');
      }

      const { CancelToken } = axios;
      const source = CancelToken.source();
      config.cancelToken = source.token;
      cancelFunctions[id] = source.cancel;
    }

    axios(config)
      .then((response) => {
        if (response.data.success) {
          resolve(response.data);
        } else {
          const code = response.data.errors[0];
          const message = errors[code];
          Vue.prototype.$notification.error({
            message: 'Ошибка',
            description: message || code,
          });
          if (code === 'ERROR_PASSWORD_EXPIRED' || code === 'ERROR_AUTH_REQUIRED') {
            store.commit('setToken', '');
            router.push('/auth');
          }
          reject(response.data.errors[0]);
        }
      })
      .catch((error) => {
        if (error.message !== 'canceled') {
          Vue.prototype.$notification.error({
            message: 'Ошибка',
            description: error.message,
          });
        }
        reject(error.message);
      })
      .finally(() => {
        if (isExclusive) {
          delete cancelFunctions[id];
        }
      });
  });
}

request('get_error_codes').then((response) => {
  errors = response.data;
});

export default {
  install: ($) => {
    // eslint-disable-next-line
    $.prototype.$api = {
      getUserInfo() {
        return request('check_auth');
      },
      register({
        name, email, password, password2,
      }) {
        return request('register', {
          name, email, password, retype_password: password2,
        });
      },
      login({ email, password }) {
        return request('login', {
          email, password,
        });
      },
      forgot({ email = '', ticket = '' }) {
        return request('iforgot', {
          email, ticket,
        });
      },
      getEntities() {
        return request('list_entities');
      },
      search({
        entity, start, length, params, sortKey, sortDir, filter, exportAs,
      }, id) {
        return request('search', {
          entity,
          start,
          length,
          params,
          order_by: sortKey,
          direction: sortDir,
          filter,
          export_as: exportAs,
        }, true, id);
      },
      editParam({
        // eslint-disable-next-line
        entity, name, gui_name, restrictor_names, restrictor_params,
        // eslint-disable-next-line
        decorator_name, modifier_name, modifier_function,
      }) {
        return request('change_entity_param_definition', {
          entity,
          name,
          gui_name,
          restrictor_names,
          restrictor_params,
          decorator_name,
          modifier_name,
          modifier_function,
        }, false, 0, 'POST');
      },
      defineEntity({
        name, gui,
      }) {
        return request('define_entity', {
          name, gui_name: gui,
        });
      },
      editEntity({
        name, id, params,
      }) {
        const config = { name };
        if (id) {
          config.id = id;
        }
        if (params) {
          config.params = JSON.stringify(params);
        }
        return request('edit_entity', config, false, 0, 'POST');
      },
      deleteEntities({
        name, filter,
      }) {
        return request('delete_entities', {
          name, filter,
        });
      },
      deleteParam({
        name, param,
      }) {
        return request('delete_entity_param', {
          entity: name, name: param,
        });
      },
      deleteEntity({
        name,
      }) {
        return request('destroy_entity', {
          name,
        });
      },
      uploadFile({
        file,
      }) {
        return request('upload_file', {
          file,
        }, null, null, 'POST');
      },
    };
  },
};
